<template>
    <a v-if="href" :href="href" class="ui-header-button">
        <slot />
    </a>
    <button v-else :type="type" class="ui-header-button">
        <slot />
    </button>
</template>

<script setup lang="ts">
/**
 * Header action button (help, notifications, color mode, user menu, …).
 * Purely structural — every admin theme styles the `ui-header-button` BEM
 * class in its CSS. Headless-UI triggers (MenuButton/PopoverButton) can't
 * wrap a component, so they apply `class="ui-header-button"` directly.
 *
 * Native elements on purpose: a string in `:is` resolves against registered
 * components first, so 'button' would hijack the global Button.
 *
 * No comments inside <template> here: dev builds keep template comments, a
 * root-level one turns the component into a fragment and its $el becomes the
 * Comment node — headlessui-float (FloatReference) then feeds it to
 * floating-ui, which crashes on getBoundingClientRect and drops the popover
 * to the top-left corner (ADMIN-FRONTEND-PN).
 */
withDefaults(
    defineProps<{
        /** Render as a link instead of a button. */
        href?: string | null;
        type?: 'button' | 'submit';
    }>(),
    {
        href: null,
        type: 'button',
    },
);
</script>
